module.exports = __webpack_public_path__ + "img/contentImg1.4c0bbf2.webp";